// src/Footer.js
import React from 'react';
import './App.css';
import { Link } from 'react-router-dom'; // ← Important

const Footer = () => (
  <>
    <br /><br /><br />
    <div className="dekfooter">
      <div className="footer">
        {/* Logo and social icons */}
        <div className="footer-logo-social">
          <div className="footer-logo">
            <img src="/img/footer.png" className="footerimg" alt="Logo"/>
          </div>
          <div className="footer-social-icons dektopsoc">
            <a href="https://www.facebook.com/paushtikkswitch#"><img src="/img/facebook.png" alt="Facebook" /></a>
            <a href="#"><img src="/img/twitter.png" alt="Twitter" /></a>
            <a href="https://www.instagram.com/paushtikkswitch/"><img src="/img/instagram.png" alt="Instagram" /></a>
            <a href="https://www.linkedin.com/company/paushtikk-switch-co/"><img src="/img/linkedin.png" alt="LinkedIn" /></a>
          </div>
        </div>

        {/* Footer links using Link */}
        <div className="footer-links">
          <ul>
            <li><Link to="/">Home</Link></li>
           <li><Link to="/careerpage">Career</Link></li>
            <li><Link to="/faqs">FAQ</Link></li>
          </ul>
          <ul>
            <li><Link to="/about">About Us</Link></li>
             <li><Link to="/collaboration">Collaboration</Link></li>
            <li><Link to="/termcondition">T&C</Link></li>
          </ul>
          <ul>
            <li><Link to="/Testimonial">Testimonials</Link></li>
            <li><a href="https://onelink.to/xgb7ab">App</a></li> {/* Possibly an external app link */}
            <li><Link to="/privacypolicy">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Contact info */}
        <div className="footer-contact">
          <div><img src="/img/email.png" alt="Email" /><a  href="mailto:makemeswitch@paushtikkswitch.com">makemeswitch@paushtikkswitch.com</a> </div>
          <div><img src="/img/time.png" alt="Hours" /> Mon - Sat | 10 AM to 8 PM</div>
          <div><img src="/img/call.png" alt="Phone" /><a href="tel:+8261931481">+91 8261931481</a> </div>
        </div>

        {/* Social icons for mobile */}
        <div className="footer-social-icons mobilesoc">
          <a href="#"><img src="/img/facebook.png" alt="Facebook" /></a>
          <a href="#"><img src="/img/twitter.png" alt="Twitter" /></a>
          <a href="#"><img src="/img/instagram.png" alt="Instagram" /></a>
          <a href="#"><img src="/img/linkedin.png" alt="LinkedIn" /></a>
        </div>

        {/* Background image */}
        <img src="/img/footerbg.png" className="footer-bg-image" alt="Footer Background" />
      </div>
    </div>
  </>
);

export default Footer;
